const METHOD_STYLE: Record<string, string> = {
    GET: 'bg-blue-50 text-blue-700 border-blue-200',
    POST: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    PATCH: 'bg-amber-50 text-amber-700 border-amber-200',
    PUT: 'bg-amber-50 text-amber-700 border-amber-200',
    DELETE: 'bg-rose-50 text-rose-700 border-rose-200'
};
const DEFAULT_METHOD_STYLE = 'bg-gray-50 text-gray-600 border-gray-200';

export function MethodTag({ method }: { method: string }) {
    const cls = METHOD_STYLE[method] ?? DEFAULT_METHOD_STYLE;
    return (
        <span
            className={`inline-flex items-center justify-center w-[58px] shrink-0 rounded border px-1.5 py-0.5 font-mono text-[10px] font-bold uppercase tracking-wide ${cls}`}
        >
            {method}
        </span>
    );
}
